/**
 * @generated SignedSource<<cdfff197b470c2b5232b49bfe6d7fadf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatasetAnalyticsFragment$data = {
  readonly downloadCount: number;
  readonly fileSize: number;
  readonly rowCount: number;
  readonly " $fragmentType": "DatasetAnalyticsFragment";
};
export type DatasetAnalyticsFragment$key = {
  readonly " $data"?: DatasetAnalyticsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetAnalyticsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetAnalyticsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadCount",
      "storageKey": null
    }
  ],
  "type": "DatasetAnalytics",
  "abstractKey": null
};

(node as any).hash = "e461cbc67e3cce5ce72102881ca17522";

export default node;
